



















import NoUISlider, { NoUISliderOptions } from '@/components/NoUISlider.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    NoUISlider
  }
})
export default class AgeRangeSelector extends Vue {
  @Prop({ required: true }) readonly value!: [number, number]
  sliderOptions: NoUISliderOptions = {
    pips: {
      mode: 'steps',
      filter: (value: number) => value % 10 ? 0 : 1
    },
    tooltips: [
      { to: Math.trunc },
      { to: Math.trunc }
    ]
  }
}
